import { type MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";

export const ejectTotalMetricValue = (
    metrics: readonly MyLensesOrganicStatsResponseEntry[],
    metricName: MetricField,
): string => {
    const [metric] = metrics;

    if (!metric) {
        return "0";
    }

    const item = metric.statsResponseTimeEntryList[0]?.statsList.find(({ field }) => field?.fieldName === metricName);

    return item?.statsList[0]?.value ?? "";
};
